<template>
  <div>
    <el-form-item
      label="Nazwa sekcji"
      :error="errors[addLanguageSuffix('name')]"
      required
    >
      <el-input v-model="section[addLanguageSuffix('name')]" />
    </el-form-item>
    <div class="inline-form-group">
      <el-form-item
        label="Nazwa widoczna dla użytkowników"
        :error="errors.display_name"
      >
        <el-switch v-model="section.display_name" />
      </el-form-item>
      <el-form-item
        label="Odpowiedzi nie moga się powtarzać"
        :error="errors.unique_answers"
      >
        <el-switch v-model="section.unique_answers" />
      </el-form-item>
    </div>
    <fields-input :fields.sync="section.fields" :errors="errors.fields || []" />
  </div>
</template>
<script>
import FieldsInput from '@/views/CustomForms/fields/FieldsInput'

export default {
  props: ['section', 'errors', 'fieldTypes'],
  components: {
    FieldsInput
  }
}
</script>
<style lang="scss"></style>
